/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { ArancelesRespuesta } from './../_models/aranceles';
import { ArancelesService } from './../_services/aranceles.service';
import { Component, OnInit } from '@angular/core';
import { componentRefresh } from '@angular/core/src/render3/instructions';

@Component({
  selector: 'app-aranceles',
  templateUrl: './aranceles.component.html',
  styleUrls: ['./aranceles.component.css']
})
export class ArancelesComponent implements OnInit {

  grupos: string[] = [
    'Asesor&iacute;a T&eacute;cnica', 'Aves', 'Animales no convencionales', 'Bovinos',
    'Equinos', 'Pequeños Animales', 'Pequeños Rumiantes', 'Porcinos',
    'Salud P&uacute;blica', 'M&eacute;todos Complementarios'
  ];
  grupo: string;
  respuesta: ArancelesRespuesta;

  constructor(private service: ArancelesService) {
    this.grupo = this.grupos[0];
    this.respuesta = new ArancelesRespuesta();
  }

  setGrupo(index) {
    this.grupo = this.grupos[index];
    console.log(this.grupos[index]);
  }

  ngOnInit() {
    this.service.getAll().subscribe(
      datos => {
        this.respuesta = datos;
      }
    );
  }

}
